module.exports = __webpack_public_path__ + "img/AITranslate.97105644.png";